import PageCommon from "../PageCommon.js";
import ServiceManager from '../../3x1010/services/ServiceManager.js';

export default class PageChristmasSpirits2024Index extends PageCommon {
  constructor() {
    super();
    this.index = 0;
    this.Questions = [];
    this.CurrentQuestion = null;
    this.CorrectAnswers = [];
    this.selectedAnswerText = null;
  }

  init($data) {
    super.init($data);
    this.showPreloader(false);
    console.log("PageChristmasSpirits2024Index");
    this.CurrentQuestion = JSON.parse(Base64.fromBase64($data?.CurrentQuestion));
    const btnEnterContest = $('.btn-enter-contest');
    btnEnterContest?.on('click', this.showQuestionPage.bind(this));

    //$data.Questions = JSON.parse(Base64.fromBase64($data.Questions));
    //$data.CorrectAnswers = JSON.parse(Base64.fromBase64($data.CorrectAnswers));
    //let day = new Date().getDate()

    //if ($data.Questions) {
    //  this.Questions = $data.Questions;
    //  this.CorrectAnswers = $data.CorrectAnswers ?? [];
    //  this.currentQuestion = $data.Questions[$data.Questions.length - 1];
    //  this.index = $data.Questions.length - 1;
    //  this.initCardQuestion();
    //}

    //const hidePreloader = setTimeout(() => {
    //  this.showPreloader(false);
    //}, 1000);

    this.initAgeCheck();
    this.initAnswersBlock();
    //// onClick show game screen
    //this.initScreenAttract();

    //// on click restart game
    //jQuery(".site-logo").on("click", () => window.location = "/");

    ///**
    // * PATCHONA PER LUNEDì
    // * */
    //if (this.currentQuestion.Numero === 1) {
    //  jQuery(".js-btn-game-card-prev").removeClass("is-disabled").addClass("is-disabled");
    //}

    //const call = ServiceManager.standardCall('api/ChristmasSpirits/getQuestions', {
    //  data: null
    //}, (rs) => {
    //  console.log(rs);
    //});

    /**
     * mobile helpers
     * */
    this.initMobileHelpers();
    this.initMobileNavigation();
    this.initMobileForm();

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    }
    catch {
      console.error()
    }
  }

  initMobileHelpers() {
    // css props
    let resizing;
    document.body.style.setProperty("--window-w", `${window.innerWidth}px`);
    document.body.style.setProperty("--window-h", `${window.innerHeight}px`);
    window.addEventListener("resize", (e) => {
      clearTimeout(resizing);
      resizing = setTimeout(() => {
        document.body.style.setProperty("--window-w", `${window.innerWidth}px`);
        document.body.style.setProperty("--window-h", `${window.innerHeight}px`);
      }, 250);
    });
  }

  initMobileNavigation() {
    const btnsNext = document.querySelectorAll(".js-btn-next-step");
    btnsNext?.forEach((btn, i) => {
      btn.addEventListener("click", (e) => {
        const parent = btn.closest(`.js-screen-step-${i}`);
        const next = document.querySelector(`.js-screen-step-${i + 1}`);

        // freeze screen
        document.body.style.setProperty("pointer-events", "none");
        parent?.classList.add("is-hidden");        

        setTimeout(() => {
          parent?.classList.add("d-none");
          next?.classList.remove("d-none");
        }, 250);

        setTimeout(() => {
          next?.classList.remove("is-hidden");
          document.body.style.removeProperty("pointer-events");
        }, 500);
      });
    });
  }

  initMobileForm() {
    const btnSubmit = $(".js-btn-form-submit");
    btnSubmit.on("click", this.sendData.bind(this, $(btnSubmit).prev()));
  }

  initAnswersBlock() {
    const answersBlock = $('.answers');
    const answers = $('li', answersBlock);
    const btnPlay = $('.btn-play', '.question-container');
    for (let answer of answers) {
      $(answer).on('click', () => {
        const selected = $('.selected', answersBlock);
        selected.removeClass('selected');
        $(answer).addClass('selected');
        btnPlay.removeClass('disabled');
        this.selectedAnswerText = $('.answer-text', answer).text();
        console.log(this.selectedAnswerText)
      });
    }    

    btnPlay.on('click', this.showFormPage.bind(this));
  }

  showFormPage() {
    const questionPageContainer = $('.question-page-container');
    questionPageContainer.addClass('hidden');

    const formPageContainer = $('.form-page-container');
    formPageContainer.removeClass('hidden');

    const btnSendData = $('.btn-send-data', formPageContainer);

    btnSendData.on('click', this.sendData.bind(this, formPageContainer));
  }

  sendData(container, event) {
    event.preventDefault();

    $('.js-nome').removeClass('error');
    $('.js-cognome').removeClass('error');
    $('.js-email').removeClass('error');
    let errors = 0;
    const nome = $('.js-nome', container).val();
    if (Pqp.isNullOrEmpty(nome)) {
      errors++;
      this._createModalFeedback('form-error-empty-fields');
      return;
    }

    const cognome = $('.js-cognome', container).val();
    if (Pqp.isNullOrEmpty(cognome)) {
      errors++;
      this._createModalFeedback('form-error-empty-fields');
      return;
    }
    const email = $('.js-email', container).val();
    if (Pqp.isNullOrEmpty(email) || !Pqp.validateEmail(email)) {
      errors++;
      this._createModalFeedback('form-error-empty-fields');
      return;
    }

    const flagPrivacy = $('.js-privacy', container).prop('checked');
    if (!flagPrivacy) {
      this._createModalFeedback('form-error-empty-fields');
      errors++;
      return;
    }

    if (errors > 0) {
      this._createModalFeedback("form-error");
      return;
    }

    const data = {
      nome: nome,
      cognome: cognome,
      email: email,
      flagPrivacy: 1
    }

    this.showPreloader(true);

    // for debugging pursoses...
    let error = false;
    let emailUsed = false;

    const rq = {
      ...data,
      Day: this.CurrentQuestion.Giorno,
      Text: this.selectedAnswerText.trim(),
    }

    //console.log(rq);
    
    ServiceManager.standardCall("api/ChristmasSpirits/saveVoto", rq, (rs) => {
      error = !rq.Success && rs.StatusCode == 404 || rs.StatusCode == 500;
      emailUsed = !rs.Success && rs.StatusCode == 400;
      // error generic
      if (error) {
        this._createModalFeedback("form-error");
        // error email already used
      } else if (emailUsed) {
        this._createModalFeedback("form-error-email");
        // no errors
      } else {
        this._createModalFeedback("form-ok");
      }

      this.showPreloader(false);
    })
  }

  showQuestionPage() {
    const landingPageContainer = $('.landing-page-container');
    landingPageContainer.addClass('hidden');
    const contestDescription = $('.contest-description');
    contestDescription.addClass('hidden');
    const questionPageContainer = $('.question-page-container');
    questionPageContainer.removeClass('hidden');
    const mobileScreen = $(".mobile-screen");
    mobileScreen.removeClass("hidden");
  }

  initCardQuestion() {
    if (!this.currentQuestion) return;
    $('.js-current-day').text(this.currentQuestion.Numero);
    $('span', '.js-current-day-month').text(this.currentQuestion.Giorno + ' dicembre');
    $('.js-game-question').text(this.currentQuestion.Domanda);
    $('.js-title-story').text(this.currentQuestion.TitoloRacconto);
    $('.js-story').text(this.currentQuestion.Racconto);
    $('.js-story-insp').text(this.currentQuestion.InspiredBy);
    const placeholderImage = '/assets/christmasspirits2024/bottle-placeholder.png';
    let urlImage = !Pqp.isNullOrEmpty(this.currentQuestion.ImmagineBottiglia) ? '/assets/christmasspirits2024/bottles/' + this.currentQuestion.ImmagineBottiglia : placeholderImage;
    $('.js-game-bottle').attr('src', urlImage);
  }

  handleClickBtnPrev() {
    this.index--;
    this.currentQuestion = this.Questions[this.index];
    const screenGame = document.querySelector(".js-screen-game");
    this.updateScreenGame(screenGame);
    this.playBookPageFlip();
  }

  handleClickBtnNext() {
    this.index++;
    this.currentQuestion = this.Questions[this.index];
    const screenGame = document.querySelector(".js-screen-game");
    this.updateScreenGame(screenGame);
    this.playBookPageFlip();
  }

  playBookPageFlip() {
    const audio = document.querySelector(".js-book-page-flip");
    if (audio) {
      audio.pause();
      audio.currentTime = 0;
      if (audio.paused) {
        audio.play();
      }
    }
  }

  /**
   * Age check
   * */
  initAgeCheck() {
    const dialog = document.querySelector(".js-age-check");

    if (Pqp.isNullOrEmpty(jQuery.cookie("wlfFlagCookie_CHRISTMASSPIRITS_AGE"))) {
      dialog?.classList.remove("is-hidden");

    } else {
        this._hideAgeCheckDialog(dialog);
        $('body').removeClass('hide-scroll');
    }

    $(".js-yes").on("click", (e) => { this._confirmAge(dialog) });
  }

  _hideAgeCheckDialog(dialog) {
    dialog?.classList.add("is-hidden");
    $("body").removeClass("hide-scroll");
    //document.querySelector("body").removeAttribute("style");

    //$('body').css('overflow-y', 'auto');
  }

  _confirmAge(dialog) {
    jQuery.cookie("wlfFlagCookie_CHRISTMASSPIRITS_AGE", "TRUE", {
      expires: 180,
      path: "/"
    });

    this._hideAgeCheckDialog(dialog);
  }

  /**
   * Screen Attract
   * */
  initScreenAttract() {
    const btn = document.querySelector(".js-btn-start-game");
    btn?.addEventListener("click", (e) => { this._showScreenGame() });
  }

  _showScreenGame() {
    // clone container
    const screenGame = document.getElementById("js-template-screen-game").cloneNode(true);
    screenGame?.removeAttribute("id");
    // clone game card
    const gameCard = document.getElementById("js-template-game-card").cloneNode(true);
    gameCard?.removeAttribute("id");

    if (screenGame && gameCard) {
      // append screen game to .app
      screenGame.appendChild(gameCard);
      document.querySelector(".js-screen-attract")?.after(screenGame);

      // hide screen attract and show screen game
      this.fadeInFadeOut(".js-screen-attract");

      // show bottle
      const showBottle = setTimeout(() => { gameCard.querySelector(".js-game-bottle")?.classList.add("is-visible") }, 800);

      // answer submission and form check
      this.initScreenGame(screenGame, gameCard);
    }
  }

  /**
   * Screen Game
   * */
  initScreenGame(screenGame, gameCard) {
    this._initScreenGameMobile(screenGame, gameCard);

    // solo a scopo dimostrativo...
    const btnsSubmitAnswer = screenGame.querySelectorAll(".js-btn-submit-answer");
    if (btnsSubmitAnswer.length > 0) {
      btnsSubmitAnswer.forEach((btn) => {
        btn.classList.add("is-not-active");
        btn.addEventListener("click", (e) => {
          if (gameCard.querySelector(".js-game-answer.is-checked")) {
            e.target.style.pointerEvents = "none";
            this.fadeInFadeOut(".js-game-step-1");
            this.fadeInFadeOut(".js-game-step-1-mobile");
            // init form
            this._initGameForm(screenGame);
            gameCard.classList.add("has-bg-form");
          }
        });
      });
    }

    const btnsPrev = screenGame.querySelectorAll(".js-btn-game-card-prev");
    btnsPrev.forEach(btnPrev => {
      btnPrev.addEventListener("click", () => {
        this.handleClickBtnPrev();
      });
    })

    const btnsNext = screenGame.querySelectorAll(".js-btn-game-card-next");
    btnsNext.forEach(btnNext => {
      btnNext.addEventListener("click", () => {
        this.handleClickBtnNext();
      });
    })

    const answers = screenGame.querySelectorAll(".js-game-answer");
    if (answers.length > 0) {
      let count = 0;
      answers.forEach((answer) => {
        if (count == 3) count = 0;
        answer.innerText = this.currentQuestion.Answers[count];
        if (answer.classList.contains("is-checked")) {
          answer.classList.remove("is-checked");
        }
        if (this.currentQuestion.Giorno != new Date().getDate() || this.currentQuestion.Numero < this.Questions.length) {
          answer.classList.contains("is-disabled") ? null : answer.classList.add("is-disabled");

          if (answer.innerText.trim() == this.CorrectAnswers[this.index]) {
            answer.classList.contains("is-disabled") ? answer.classList.remove("is-disabled") : null;
            answer.classList.contains('is-checked') ? null : answer.classList.add('is-checked');
          }
        }
        else {
          !answer.classList.contains("is-disabled") ? null : answer.classList.remove("is-disabled");
        }
        answer.addEventListener("click", (e) => {
          if (this.currentQuestion.Giorno == new Date().getDate()) {
            jQuery(".is-checked", screenGame).not(answer).removeClass("is-checked");
            answer.classList.toggle("is-checked");
            this.selectedAnswerText = $(answer).text();

            if (answer.classList.contains("is-checked")) {
              answer.closest(".game-play")?.querySelector(".js-btn-submit-answer")?.classList.remove("is-not-active");
            } else {
              if (!answer.closest(".game-play")?.querySelector(".js-btn-submit-answer")?.classList.contains("is-not-active")) {
                answer.closest(".game-play")?.querySelector(".js-btn-submit-answer")?.classList.add("is-not-active");
              }
            }
          }
        });
        count++;
      });
    }

    //const btnAnswerSubmit = screenGame.querySelector('.js-btn-submit-answer');
    //btnAnswerSubmit.classList.remove("is-not-active");
  }

  updateScreenGame(screenGame) {
    let currentNumberContainers = screenGame.querySelectorAll('.js-current-day');
    currentNumberContainers.forEach((container) => {
      container.innerText = this.currentQuestion.Numero;
    })

    let currentDayContainer = screenGame.querySelectorAll('.js-current-day-month');
    currentDayContainer.forEach((container) => {
      const currentDay = container.querySelector('span');
      currentDay.innerText = this.currentQuestion.Giorno + " dicembre";
    })

    let questionContainer = screenGame.querySelectorAll('.js-game-question');
    questionContainer.forEach((container) => {
      container.innerText = this.currentQuestion.Domanda;
    })

    let titoloRaccontoContainer = screenGame.querySelectorAll('.js-title-story');
    titoloRaccontoContainer.forEach((container) => {
      container.innerText = this.currentQuestion.TitoloRacconto;
    })


    let raccontoContainer = screenGame.querySelectorAll('.js-story');
    raccontoContainer.forEach((container) => {
      container.innerText = this.currentQuestion.Racconto;
    })

    const placeholderImage = '/assets/christmasspirits2024/bottle-placeholder.png';
    let urlImage = !Pqp.isNullOrEmpty(this.currentQuestion.ImmagineBottiglia) ? '/assets/christmasspirits2024/bottles/' + this.currentQuestion.ImmagineBottiglia : placeholderImage;
    $('.js-game-bottle').attr('src', urlImage);

    const answers = screenGame.querySelectorAll(".js-game-answer");
    let count = 0;
    answers.forEach((answer) => {

      if (count == 3) count = 0;
      answer.innerText = this.currentQuestion.Answers[count];
      if (answer.classList.contains("is-checked")) {
        answer.classList.remove("is-checked");
      }
      if (this.currentQuestion.Giorno != new Date().getDate() || this.currentQuestion.Numero < this.Questions.length) {
        answer.classList.contains("is-disabled") ? null : answer.classList.add("is-disabled");

        if (answer.innerText.trim() == this.CorrectAnswers[this.index]) {
          answer.classList.contains("is-disabled") ? answer.classList.remove("is-disabled") : null;
          answer.classList.contains('is-checked') ? null : answer.classList.add('is-checked');
        }
      }
      else {
        !answer.classList.contains("is-disabled") ? null : answer.classList.remove("is-disabled");
      }

      count++;
    });

    if (this.currentQuestion.Numero == 1) {
      let btnsPrev = screenGame.querySelectorAll('.js-btn-game-card-prev');
      btnsPrev.forEach(btnPrev => {
        $(btnPrev).addClass('is-disabled');
      })

      if (this.currentQuestion.Numero < this.Questions.length) {
        let btnsNext = screenGame.querySelectorAll('.js-btn-game-card-next');
        btnsNext.forEach(btnNext => {
          $(btnNext).hasClass('is-disabled') ? $(btnNext).removeClass('is-disabled') : null;
        })

        let classesScreengame = screenGame.querySelectorAll('.js-question-expired');
        classesScreengame.forEach(classes => {
          classes.classList.contains('is-hidden') ? classes.classList.remove('is-hidden') : null;
        })
      }
    }
    else if (this.currentQuestion.Numero == this.Questions.length) {

      let btnsPrev = screenGame.querySelectorAll('.js-btn-game-card-prev');
      btnsPrev.forEach(btnPrev => {
        $(btnPrev).hasClass('is-disabled') ? $(btnPrev).removeClass('is-disabled') : null;
      })

      let btnsNext = screenGame.querySelectorAll('.js-btn-game-card-next');
      btnsNext.forEach(btnNext => {
        $(btnNext).hasClass('is-disabled') ? null : $(btnNext).addClass('is-disabled');
      })

      let classesScreengame = screenGame.querySelectorAll('.js-question-expired');
      classesScreengame.forEach(classes => {
        classes.classList.contains('is-hidden') ? null : classes.classList.add('is-hidden');
      })
    }
    else {

      let btnsPrev = screenGame.querySelectorAll('.js-btn-game-card-prev');
      btnsPrev.forEach(btnPrev => {
        $(btnPrev).hasClass('is-disabled') ? $(btnPrev).removeClass('is-disabled') : null;
      })

      let btnsNext = screenGame.querySelectorAll('.js-btn-game-card-next');
      btnsNext.forEach(btnNext => {
        $(btnNext).hasClass('is-disabled') ? $(btnNext).removeClass('is-disabled') : null;
      })

      let classesScreengame = screenGame.querySelectorAll('.js-question-expired');
      classesScreengame.forEach(classes => {
        classes.classList.contains('is-hidden') ? classes.classList.remove('is-hidden') : null;
      })
    }

    let storyInspContainer = screenGame.querySelectorAll('.js-story-insp');
    storyInspContainer.forEach((container) => {
      container.innerText = this.currentQuestion.InspiredBy;
    });

    const btnAnswerSubmit = screenGame.querySelector('.js-btn-submit-answer');
    btnAnswerSubmit.classList.add("is-not-active");
  }

  _initScreenGameMobile(screenGame, gameCard) {
    const swiper = screenGame.querySelector(".js-game-step-1-mobile");
    const btnNextSlide = swiper.querySelector(".js-swiper-game-button-next");
    // init swiper
    const swiperStep1 = new Swiper(swiper, {
      navigation: {
        nextEl: btnNextSlide
      }
    });
  }

  _initGameForm(screenGame) {
    // fit form on desktop devices
    const btnsCheckForm = screenGame.querySelectorAll(".js-btn-check-form");
    if (btnsCheckForm.length > 0) {
      btnsCheckForm.forEach((btn) => {
        btn.addEventListener("click", (e) => { this._checkForm(e, screenGame, new FormData(btn.closest(".js-game-form"))) });
      });
    }
  }

  /* IMPORTANTE: DA AGGIUNGERE LA RISPOSTA AI DATI... */
  _checkForm(e, screenGame, formData) {
    e.preventDefault();
    const cognome = formData.get("name");
    const name = formData.get("name");
    const regName = /[a-zA-Z]/;
    const email = formData.get("email");
    const privacyPolicy = formData.get("privacy-policy");
    let errors = 0;

    jQuery(".has-error").removeClass("has-error");

    if (Pqp.isNullOrEmpty(name)) {
      errors++;
      const parent = jQuery(".js-name")?.closest(".single-input-wrap");
      parent?.addClass("has-error");
      jQuery(".js-input-error", parent).text("Questo campo è obbligatorio");

    }
    //else if (!regName.test(name)) {
    //  errors++;
    //  const parent = jQuery(".js-name")?.closest(".single-input-wrap");
    //  jQuery(".js-input-error", parent).text("Il formato inserito non è corretto: non sono ammessi i caratteri speciali e i numeri");
    //  parent?.addClass("has-error");

    //}
    else if (name.length > 100) {
      errors++;
      const parent = jQuery(".js-name")?.closest(".single-input-wrap");
      jQuery(".js-input-error", parent).text("Il nome inserito è troppo lungo!");
      parent?.addClass("has-error");
    }
    else {
      jQuery(".js-name")?.closest(".single-input-wrap").addClass("is-ok");
    }

    if (Pqp.isNullOrEmpty(cognome)) {
      errors++;
      const parent = jQuery(".js-cognome")?.closest(".single-input-wrap");
      parent?.addClass("has-error");
      jQuery(".js-input-error", parent).text("Questo campo è obbligatorio");

    }

    else if (name.length > 100) {
      errors++;
      const parent = jQuery(".js-cognome")?.closest(".single-input-wrap");
      jQuery(".js-input-error", parent).text("Il cognome inserito è troppo lungo!");
      parent?.addClass("has-error");
    }
    else {
      jQuery(".js-cognome")?.closest(".single-input-wrap").addClass("is-ok");
    }

    if (Pqp.isNullOrEmpty(email) || !Pqp.validateEmail(email)) {
      errors++;
      const parent = jQuery(".js-email")?.closest(".single-input-wrap");

      if (Pqp.isNullOrEmpty(email) && email.length === 0) {
        jQuery(".js-input-error", parent).text("Questo campo è obbligatorio!");
      }

      if (!Pqp.validateEmail(email) && email.length > 0) {
        jQuery(".js-input-error", parent).text("Il campo non è stato compilato correttamente");
      }

      parent?.addClass("has-error");

    } else {
      jQuery(".js-email")?.closest(".single-input-wrap").addClass("is-ok");
    }

    if (Pqp.isNullOrEmpty(privacyPolicy)) {
      errors++;
      jQuery(".js-privacy-policy")?.next().addClass("has-error");
    }

    if (errors === 0) {
      e.target.style.pointerEvents = "none";

      // wrap data and send it
      const data = {
        nome: name,
        cognome: cognome,
        email: email,
        flagPrivacy: 1
      }

      this._sendData(data);
    }
  }

  _sendData(data) {
    this.showPreloader(true);

    // for debugging pursoses...
    let error = false;
    let emailUsed = false;

    const rq = {
      ...data,
      Day: this.currentQuestion.Giorno,
      Text: this.selectedAnswerText.trim(),
    }

    ServiceManager.standardCall("api/ChristmasSpirits/saveVoto", rq, (rs) => {
      error = !rq.Success && rs.StatusCode == 404 || rs.StatusCode == 500;
      emailUsed = !rs.Success && rs.StatusCode == 400;
      // error generic
      if (error) {
        this._createModalFeedback("form-error");
        // error email already used
      } else if (emailUsed) {
        this._createModalFeedback("form-error-email");
        // no errors
      } else {
        this._createModalFeedback("form-ok");
      }

      this.showPreloader(false);
    })
  }

  _createModalFeedback(id) {
    const modal = document.getElementById(id).cloneNode(true);
    modal.removeAttribute("id");

    // close modal
    modal.querySelector(".js-dialog-close")?.addEventListener("click", (e) => {
      if (id === "form-error-email" || id === 'form-error-empty-fields') {
        jQuery(modal).fadeOut(() => modal.remove());
        jQuery(".js-btn-check-form").removeAttr("style");
      } else {
        window.location.reload();
      }
    });

    // reload location
    modal.querySelector(".js-reload")?.addEventListener("click", (e) => {
      if (id === "form-error-email" || id === 'form-error-empty-fields') {
        jQuery(modal).fadeOut(() => modal.remove());
        jQuery(".js-btn-check-form").removeAttr("style");
      } else {
        window.location.reload();
      }
    });

    document.querySelector(".app").appendChild(modal);
    jQuery(modal).fadeIn();
  }

  /**
   * Helpers
   * */
  // hide current element and show next sibling, then remove current element's node
  fadeInFadeOut(currentScreen) {
    jQuery(currentScreen).fadeOut(() => {
      jQuery(currentScreen).next().fadeIn(() => jQuery(currentScreen).remove());
      if (currentScreen == '.js-game-step-1' || currentScreen == '.js-game-step-1-mobile') {
        document.querySelector('.js-game-card').querySelector(".js-btn-game-card-prev").classList.add('is-disabled');
        document.querySelector('.js-game-card').querySelector(".js-btn-game-card-next").classList.add('is-disabled');
      }
    });
  }
}

PageChristmasSpirits2024Index.index = 0;
PageChristmasSpirits2024Index.selectedAnswerText = '';